import React from 'react'

const Icons = () => {
    return (
        <div className='icons-container'>
          <img
          className='icon heart-icon'
          src='../icons/heart.svg'
          alt='heart-icon'
          />
        <img
          className='icon play-icon'
          src='../icons/play.svg'
          alt='play-icon'
          />
        <img
          className='icon dots-icon'
          src='../icons/dots.svg'
          alt='dots-icon'
          />
        </div>
    )
}

export default Icons;